export const getSelectedStore = () => {
    try {
        const storeData = window.localStorage.getItem('selectedStore');
        if (!storeData) return null;
        const parsedData = JSON.parse(storeData);
        return parsedData?.id || null;
    } catch (error) {
        console.error('Error parsing selectedStore from localStorage:', error);
        return null;
    }
}; 